<div  ng2FileDrop (fileOver)="cloudinaryService.fileOverBase($event)" class="container edit-question-container font-title">
<form *ngIf="isFormReady">
    <h3> {{ 'editQuiz.text1' | translate }}</h3>
    <div class="form-group">
    <!--[(ngModel)]="quizzes"-->
        <select (change)="getQuizByStorySelection($event.target.value)" name="quizIdSelect"  class="custom-select">
            <option *ngFor="let quiz of quizzes" [value]="quiz.quizId">{{ quiz.storyName }}</option>
        </select>
    </div>
    <div class="error-section-container" *ngIf="showErrorSection">
        <h3>{{ 'editQuiz.text2' | translate }}</h3>
    </div>
    <div class="edit-quiz-form-container" *ngIf="isSelectedQuiz">
    <!-- *ngIf="isSelectedQuiz" -->
     <div class="question-btn-container form-group">
        <button type="btn" class="btn btn-primary" (click)="populatePreviousQuestion()" [disabled]="!enablePreviousQuestionButton">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-circle" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-4.5-.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
            </svg>
            {{ 'editQuiz.text3' | translate }}
        </button>
        <button type="btn" class="btn btn-primary" (click)="populateNextQuestion()" [disabled]="!enableNextQuestionButton">
            {{ 'editQuiz.text4' | translate }}
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8zm15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
            </svg>
        </button>
    </div>
    <div class="form-group">
        <label for="question">{{ 'editQuiz.text5' | translate }}</label>
        <input type="text" class="form-control" name="questionText" [(ngModel)]="selectedQuiz.questionAndAnswersDTO[currentQuestionIndex].questionDTO.questionText" />
    </div>
    <div class="form-group">
        <label for="answer1">{{ 'editQuiz.text6' | translate }}</label>
        <input type="text" class="form-control" name="answerChoice1" [(ngModel)]="selectedQuiz.questionAndAnswersDTO[currentQuestionIndex].answersDTO[0].answerText"/>
    </div>
    <div class="form-group">
        <label for="answer2">{{ 'editQuiz.text7' | translate }}</label>
        <input type="text" class="form-control" name="answerChoice2" [(ngModel)]="selectedQuiz.questionAndAnswersDTO[currentQuestionIndex].answersDTO[1].answerText"/>
    </div>
    <div class="form-group">
        <label for="answer3">{{ 'editQuiz.text8' | translate }}</label>
        <input type="text" class="form-control" name="answerChoice3" [(ngModel)]="selectedQuiz.questionAndAnswersDTO[currentQuestionIndex].answersDTO[2].answerText"/>
    </div>
    <div class="form-group">
        <label for="answer4">{{ 'editQuiz.text9' | translate }}</label>
        <input type="text" class="form-control" name="answerChoice4" [(ngModel)]="selectedQuiz.questionAndAnswersDTO[currentQuestionIndex].answersDTO[3].answerText"/>
    </div>
    <div class="form-group">
        <mat-form-field appearance="fill" class="font-title">
            <mat-label>{{ 'editQuiz.text10' | translate }}</mat-label>
            <mat-select (selectionChange)="updateAnswerOption($event)" [(value)]="correctAnswerOptionValue" class="form-select">
            <mat-option *ngFor="let answerOption of answerOptions" [value]="answerOption.answerValue">
                {{answerOption.answerText}}
            </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

     <div class="form-group question-image-container" *ngIf="isSelectedQuiz" >
        <label for="currentQuestionImage"><h3>{{ 'editQuiz.text11' | translate }} </h3></label>
        <img [src]="currentQuestionImageURL" name="questionImage" id="question-image"/>
        <!-- [(ngModel)]="currentQuestionImageURL"-->
    </div>

    <div id="direct_upload" ng2FileDrop [uploader]="cloudinaryService.uploader" (fileOver)="cloudinaryService.fileOverBase($event)" [ngClass]="{'nv-file-over': cloudinaryService.hasBaseDropZoneOver}">
        <h3>> {{ 'editQuiz.text12' | translate }}</h3>
        <form>
            <div class="form_line">
                <div class="form_control">
                    <div class="upload_button_holder file-path-wrapper">
                        <input type="file" id="fileupload" class="" #fileInput ng2FileSelect  [uploader]="cloudinaryService.uploader" (change)="questionImageChanged(); fileInput.value=''"/>
                        <!---->
                    </div>

                </div>
            </div>
        </form>
        <br>
        <h4>{{ 'editQuiz.text13' | translate }}</h4>
        <div class="file" *ngFor="let response of cloudinaryService.responses; let i = index">
            <h3>{{response.file.name}}</h3>
        <button class="delete-image" *ngIf="!!response.data.delete_token" (click)="cloudinaryService.deleteImage(response.data, i)">{{ 'uploadDialog.text1' | translate }}</button>
            <div class="status">
                {{ 'uploadDialog.text2' | translate }} {{response.progress}}%
                <div *ngIf="!response.status">{{ 'uploadDialog.text3' | translate }}</div>
                <div class="status-code" *ngIf="response.status">{{ 'uploadDialog.text4' | translate }} {{response.status}}</div>
            </div>
            <div class="progress-bar">
                <div class="progress" role="progressbar" [style.width.%]="response.progress"></div>
            </div>
            <div class="form_line">
                <div class="form_controls">
                    <div class="preview">
                    </div>
                </div>
            </div>

        </div>

    </div>

    <div class="mb-16"></div>
    <button type="submit" class="btn btn-default white-btn" (click)="onSubmit(editQuizForm)" [disabled]="!isFormSubmitReady">{{ 'editQuiz.text14' | translate }}</button>
    </div>
</form>
</div>
